var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"page-bottom-progress",attrs:{"indeterminate":true,"color":"red lighten-1"}})}
var staticRenderFns = []

export { render, staticRenderFns }